var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPasswordreset = function SvgPasswordreset(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 119,
    viewBox: "0 0 121 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.7793 67.138C69.8546 78.0627 51.9641 77.8846 40.8198 66.7404C29.6755 55.5961 29.4975 37.7056 40.4222 26.7809C51.3469 15.8562 69.2374 16.0342 80.3817 27.1785C91.5259 38.3228 91.704 56.2133 80.7793 67.138Z",
    fill: "url(#paint0_linear_452_13568)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_452_13568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4863 87.0693C71.5001 100.056 50.2336 99.844 36.9863 86.5967C23.739 73.3494 23.5274 52.0829 36.5137 39.0967C49.4999 26.1104 70.7664 26.3221 84.0137 39.5693C97.2609 52.8166 97.4726 74.0831 84.4863 87.0693Z",
    fill: "#6AE092",
    fillOpacity: 0.6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3571 66.4627C56.403 66.5086 56.4653 66.5344 56.5302 66.5344C56.5951 66.5344 56.6573 66.5086 56.7032 66.4627L70.6688 52.4971C71.9506 51.2153 74.0289 51.2153 75.3107 52.4971C76.5925 53.7789 76.5925 55.8572 75.3107 57.139L58.8511 73.5986C58.2356 74.2141 57.4007 74.5599 56.5302 74.5599C55.6597 74.5599 54.8248 74.2141 54.2092 73.5986L44.8038 64.1931C43.522 62.9113 43.522 60.8331 44.8038 59.5512C46.0856 58.2694 48.1638 58.2694 49.4456 59.5512L56.3571 66.4627Z",
    fill: "url(#paint1_linear_452_13568)",
    fillOpacity: 0.9,
    stroke: "url(#paint2_linear_452_13568)",
    strokeWidth: 0.489516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_452_13568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8237 82.7581C51.4502 93.3846 68.8576 93.1315 79.7036 82.2855C90.5497 71.4395 90.8028 54.0321 80.1763 43.4056C69.5498 32.779 52.1424 33.0322 41.2964 43.8782C30.4503 54.7242 30.1972 72.1316 40.8237 82.7581Z",
    stroke: "url(#paint3_linear_452_13568)",
    strokeWidth: 2.44758
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_452_13568",
    x: 13.2343,
    y: 15.8183,
    width: 94.5314,
    height: 94.5294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6.83793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_452_13568"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_452_13568",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_452_13568",
    x: 18.1054,
    y: 20.6874,
    width: 84.7892,
    height: 84.7882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6.83793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_452_13568"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_452_13568",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_452_13568",
    x1: 32.1043,
    y1: 43.0934,
    x2: 81.8709,
    y2: 38.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75EDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#349256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_452_13568",
    x1: 48.742,
    y1: 60.2562,
    x2: 100.179,
    y2: 66.3351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_452_13568",
    x1: 44.5336,
    y1: 54.6449,
    x2: 65.576,
    y2: 61.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_452_13568",
    x1: 11.5272,
    y1: 36.1401,
    x2: 87.9182,
    y2: 80.0413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPasswordreset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "passwordreset.6592ed17bd97a4583bb018cee1cb0e0d.svg";